export enum ICON_STATES {
  PENDING = "pending",
  SUCCESS = "success",
}
